import { render, staticRenderFns } from "./HorizontalNavMenuGroup.vue?vue&type=template&id=63ee6048&"
import script from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNavMenuGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ee6048')) {
      api.createRecord('63ee6048', component.options)
    } else {
      api.reload('63ee6048', component.options)
    }
    module.hot.accept("./HorizontalNavMenuGroup.vue?vue&type=template&id=63ee6048&", function () {
      api.rerender('63ee6048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/horizontal-nav-menu/HorizontalNavMenuGroup.vue"
export default component.exports